import { Injectable, Injector } from "@angular/core";
import { Art57Section } from "../../ui/Art57Section/Art57Section";

@Injectable({ providedIn: 'root' })
export class TrackerServiceComponent {

  constructor(
    private injector: Injector) {
  }

  private activeRequests = new Set<string>();

  start(key: string): boolean {
    if (this.activeRequests.has(key)) {
      this.injector.get(Art57Section).showWarningTooltipMessage('Action under execution');
      return false;
    }

    this.activeRequests.add(key);
    return true;
  }

  stop(key: string): void {
    this.activeRequests.delete(key);
  }

  isActive(key: string): boolean {
    return this.activeRequests.has(key);
  }
}